import mitt from 'mitt';
import type { Events } from 'src/bus/events';

const bus = mitt<Events>();

export function busCreator() {
    return mitt();
}

export default bus;
